<template>
  <div class="c-single-generation">
    <Container class="c-single-generation-container" >
      <div class="c-single-generation_wrapper" v-if="step === 0">
        <div class="c-single-generation_wrapper-info">
          <h1 class="c-single-generation_wrapper-info-headline">
            <span>D</span>ress <span>D</span>own <span>AI</span><br> Will make Any Woman Naked In 30 seconds
          </h1>
          <div class="c-single-generation_wrapper-info_desc">
            <label
              :for="generatedImage === '' ? `uploadImg` : ''"
              class="generation_upload"
              @dragover.prevent
              @drop="handleDrop"
              :class="{ 'generation_upload--removed': currentImage.file }"
            >
              <div class="generation-container-image">
                <img
                  v-if="currentImage.src"
                  class="generation_upload-image"
                  :src="currentImage.src"
                  alt="uploaded image"
                />
                <template v-if="!currentImage.src">
                  <img
                    class="generation_upload-icon"
                    src="@/assets/icons/upload-image.svg"
                    alt="upload file upload-some"
                    draggable="false"
                  />
                  <h2 class="generation-container-image_title">
                    Upload an image to get started
                  </h2>
                  <p class="generation-container-image_description">
                    Supported files: .jpg .png .heic
                  </p>
                  <p class="generation-container-image_description">
                    All created images are automatically deleted within 24 hours
                  </p>
                </template>
              </div>

              <input
                v-show="false"
                id="uploadImg"
                type="file"
                @input.stop="handleFile"
                name="img"
                accept="image/*"
              />
            </label>
          </div>
          <Button
            class="c-single-generation_wrapper-info_button"
            @click="changeStepOne(1)"
            @touchstart="changeStepOne(1)"
            text="buttons.main"
          />
          <div class="c-single-generation_wrapper-footer_desc">
            <p>
              upload a picture of a <span>woman</span> you want to see <span>naked</span>, select your favorite look and download a <span>high-quality</span> image
            </p>
          </div>
        </div>
        <div class="c-single-generation_wrapper-right">
          <div class="c-single-generation_wrapper-right-item">
            <img src="@/assets/img/grid-img.png" alt="single generation content" >
          </div>
        </div>
      </div>

      <div class="c-single-generation_wrapper wrapper-filters" v-if="step === 1">
        <div class="c-single-generation_wrapper-image-holder">
          <div class="c-single-generation_wrapper-image-holder-item">
            <img
              v-if="currentImage.src"
              class="generation_upload-image"
              :src="currentImage.src"
              alt="uploaded image"
            />
          </div>
        </div>
        <div class="c-single-generation_wrapper-filters-line"></div>
        <div class="c-single-generation_wrapper-filters">
          <p class="c-single-generation_wrapper-filters-title">
            Select type of <span>images</span>
          </p>

          <div class="c-single-generation_wrapper-filters-list">
            <div
              v-for="image in images"
              :key="image.id"
              class="c-single-generation_wrapper-filters-item"
              :class="{
                'inactive': !image.isActive,
                'selected': image.selected
              }"
              @click="handleFilter(image)"
              @touchstart="handleFilter(image)"
            >
              <div class="image-holder">
                <img
                  :src="image.img"
                  alt="single generation content"
                >
              </div>
              <p>{{ image.title }}</p>
            </div>
          </div>
          <Button
            class="c-single-generation_wrapper-info_button"
            @click="changeStepTwo(2)"
            text="Create your first FREE Image"
          />
        </div>
      </div>

      <div class="c-single-generation_wrapper wrapper-generation" v-if="step === 2">
        <div class="generation-container">
          <label
            :for="generatedImage === '' ? `uploadImg` : ''"
            class="generation_upload"
            @dragover.prevent
            @drop="handleDrop"
            :class="{ 'generation_upload--removed': currentImage.file }"
          >
            <template v-if="!isInOrder">
              <img
                v-if="currentImage.src && percentage < 100"
                class="generation_upload-image"
                :src="currentImage.src"
                alt="uploaded image"
              />
              <div
                v-if="!currentImage.src && generatedImage === ''"
                class="generation-container-image"
              >
                <img
                  class="generation_upload-icon"
                  src="@/assets/icons/upload-image.svg"
                  alt="upload file image upload-some"
                  draggable="false"
                />
                <h2 class="generation-container-image_title">
                  {{ $t("edit.dragNDrop") }}
                </h2>
                <p class="generation-container-image_description">
                  {{ $t("edit.fileSupported") }}
                </p>
              </div>

              <img
                @click="invokeZoom"
                @touchstart="invokeZoom"
                v-if="generatedImage !== '' && percentage >= 100"
                class="generation_upload-image"
                :src="generatedImage"
                alt="upload file image upload-some"
              />

              <div v-if="generatedImage !== '' && percentage >= 100" class="zoom-image-buttons">
                <button
                  @click="downloadImage"
                  @touchstart="downloadImage"
                  class="zoom-image-buttons_download"
                >
                  <img src="@/assets/icons/download.svg" alt="download-icon">
                </button>
              </div>
            </template>
            <div class="generation-uploading" v-else>
              <img
                class="generation_upload-image"
                :src="currentImage.src"
                alt="uploaded image"
              />
              <div class="generation-uploading--background"></div>
              <LoadAnimation
                v-show="percentage >= 100"
                class="generation-uploading--loader"
              />
              <ProgressBarPercentage
                v-show="percentage < 100"
                :percentage="percentage"
              />
              <div
                v-show="percentage < 100"
                class="generation-uploading-percentage"
              >
                GENERATING NOW......
              </div>
              <div
                v-show="percentage < 100"
                class="generation-uploading-info"
              >
                Loading takes up to 1 minute
              </div>
              <div
                v-show="percentage >= 100"
                class="generation-uploading-text-after"
              >
                {{ $t("generation.almostDone") }}
              </div>
              <div
                v-show="percentage >= 100"
                class="generation-uploading-text-almost-complete"
              >
                {{ $t("generation.almostComplete") }}
              </div>
            </div>
            <input
              v-show="false"
              id="uploadImg"
              type="file"
              @input.stop="handleFile"
              name="img"
              accept="image/*"
            />
          </label>
          <p
            v-if="generatedImage !== '' && percentage >= 100 && !isInOrder"
            class="generation-info"
          >
            Blur and watermark disappear upon purchasing Credits. <br> Buy Credits <span>Now</span> to access all AI features.
          </p>

          <div
            v-if="generatedImage !== '' && percentage >= 100 && !isInOrder"
            class="generation-invoke-filters"
          >
            <button
                @click="uploadNewPhoto"
                class="generation-invoke-filters_button"
            >
              {{ $t("buttons.createNew") }}
            </button>
            <button
                @click="changeStepTwo(2)"
                class="generation-invoke-filters_button green-btn-with-pulse"
            >
              {{ $t("buttons.showFilters") }}
            </button>
            <button
                @click="handleGenerate"
                @touchstart="handleGenerate"
                class="generation-invoke-filters-cancel"
            >
              {{ $t("buttons.remove") }}
            </button>
          </div>
        </div>
      </div>
    </Container>
    <CheckAgeTextModal v-if="isOpenAgeVerificationModal"/>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

// i18n
import { useI18n } from 'vue-i18n';

// components
import Container from "./layout-positions/Container";
import Button from "./Button";
import LoadAnimation from "@/components/animations/LoadAnimation.vue";
import ProgressBarPercentage from "@/components/animations/ProgressBarPercentage.vue";
import SelectType from "@/components/modals/SelectType.vue";

// assets
import bikiniImage from "@/assets/filters-bikini/black.webp";
import undressImage from "@/assets/filter-type-image/undress.png";
import breastClampImage from "@/assets/breast/woman.webp";
import cumInMouthImage from "@/assets/cumMouth/nurse.webp";
import missionaryImage from "@/assets/mission/teacher.webp";
import blowjobImage from "@/assets/bbc/nun.webp";

// utils
import { getCookie } from "@/utils/cookies";
import CheckAgeTextModal from "@/components/modals/CheckAgeTextModal.vue";
import ZoomImage from "@/components/modals/ZoomImage.vue";

export default {
  name: "SingleGenerationContent",

  components: {
    ZoomImage,
    CheckAgeTextModal,
    Button,
    Container,
    LoadAnimation,
    ProgressBarPercentage,
    SelectType,
  },

  setup() {
    // store
    const store = useStore();

    // router
    const router = useRouter();

    // i18n
    const { t } = useI18n();

    // refs
    const currentImage = ref({
      src: ""
    });

    const requestId = ref("");
    const isOpenAgeVerificationModal = ref(false)
    const watcherTimer = ref(30000);
    const lastSelectedFilter = ref(null);

    const isGenerating = ref(false);
    const percentage = ref(0);
    const intervalStatus = ref(null);
    const intervalLoad = ref(null);
    const step = ref(0);

    const images = ref([
      {
        id: 1,
        title: "Sex Clothes",
        img: bikiniImage,
        value: "bikini",
        isActive: true,
        selected: true,
        isCollage: false,
      },
      {
        id: 2,
        title: "Undress",
        img: undressImage,
        value: "undress",
        isActive: false,
        selected: false,
        isCollage: false,
      },
      {
        id: 3,
        title: "Sex poses",
        img: [
          blowjobImage
        ],
        isCollage: true,
        value: "sexPoses",
        isActive: false,
        selected: false,
      },
    ]);

    // computed
    const isValid = computed(() => {
      return !!currentImage.value.file;
    });

    const generatedImage = computed(() => {
      return store.getters.getGeneratedImage;
    });

    const isInOrder = computed(() => {
      return store.getters.isInOrder;
    });

    const getMyBalance = computed(() => {
      return store.getters.getMyBalance;
    });

    // methods
    const redirectToSignUp = () => {
      router.push("/sign-up");
    };

    const changeStepOne = (value) => {
      if (currentImage.value.src) {
        step.value = value;
        if (value === 1) {
          store.commit('addModal', 'SelectType');
        }
      } else {
        document.querySelector('#uploadImg').click();
      }
    };

    const uploadNewPhoto = () => {
      store.dispatch("trackTraffic", 'upload_new');
      router.push('/')
    }

    const removeImage = () => {
      percentage.value = 0;
      currentImage.value = { src: "" };
      generatedImage.value = "";
      clearInterval(intervalStatus.value);
      clearInterval(intervalLoad.value);
      intervalStatus.value = null;
      intervalLoad.value = null;
      const fileInput = document.querySelector("#uploadImg");
      fileInput.value = "";
      store.commit("clearOrderId");
      store.commit("setGeneratedImage", "");
    }


    const changeStepTwo = (value) => {
      const activeImage = images.value.find(image => image.selected);
      if (activeImage) {
        if (activeImage.isActive) {
          step.value = value;
          handleGenerate();
          store.commit('removeAllModal');
        } else {
          store.dispatch("handleToast", {
            text: "This generation is available only for registered users with credits. Buy credits Now to use all features",
            type: "WARNING",
          });
        }
      } else {
        images.value[0].selected = true;
        step.value = value;
        handleGenerate();
        store.commit('removeAllModal');
      }
    };

    const handleFile = (event) => {
      if (currentImage.value.file) {
        store.dispatch("handleToast", {
          text: "Sorry, you have to remove previous image!",
          type: "WARNING",
        });
        return;
      }
      percentage.value = 0;
      const image = event.target.files[0];

      if (image.size >= 15000000) {
        store.dispatch("handleToast", {
          text: "The image size must not exceed 15 MB.",
          type: "WARNING",
        });
        return;
      }

      currentImage.value = {
        file: image,
        src: URL.createObjectURL(image),
      };
    };

    const handleDrop = (event) => {
      percentage.value = 0;
      event.preventDefault();
      const file = event.dataTransfer.files[0];

      if (file.size >= 10485760) {
        store.dispatch("handleToast", {
          text: "The image size must not exceed 10 MB.",
          type: "WARNING",
        });
        return;
      }

      if (file && file.type.startsWith("image/")) {
        handleFile({ target: { files: [file] } });
      }
    };

    const handleGenerate = async (filter) => {
      if (isGenerating.value) return;

      store.commit("setOrder", "loaded");

      isGenerating.value = true;
      isOpenAgeVerificationModal.value = true;
      await justUndressRequest().finally(() => {
        const timeout = setTimeout(() => {
          isOpenAgeVerificationModal.value = false
          clearTimeout(timeout);
        }, 1000);
      });;
    };

    const justUndressRequest = async () => {
      try {
        const formData = new FormData();
        formData.append("image", currentImage.value.file);

        if (requestId.value) {
          formData.append("task_id", requestId.value);
        }

        store.commit('addModal', 'CheckAgeTextModal');
        const response = await store.dispatch("generateGirlOnce", formData);
        if (
          response.name === "AxiosError" ||
          response.message === "Network Error"
        ) {
          await store.dispatch("handleToast", {
            type: "ERROR",
            text: JSON.parse(response.request.response).error,
          });

          store.commit('addModal', 'RegisterNowModal');

          return;
        }

        requestId.value = JSON.parse(response.request.response).id;

        createWatcher();
        createLoadWatcher();
        // await store.dispatch("getUserProfile");
      } catch (error) {
        await store.dispatch("handleToast", {
          type: "ERROR",
          text: error.message,
        });
      } finally {
        isGenerating.value = false;
      }
    };

    const handleFilter = (image) => {
      store.dispatch("trackTraffic", 'select_images');
      images.value.forEach(item => {
        item.selected = false;
      });
      image.selected = true;
    };

    const openPopupMore = () => {
      store.commit('addModal', 'RegisterNowModal')
    };

    const openPopupOver = () => {
      store.commit('addModal', 'GenerationsOverModal')
    };

    const invokeZoom = () => {
      store.commit("addModal", "ZoomImage");
    };

    const createLoadWatcher = () => {
      if (percentage.value >= 100) {
        clearInterval(intervalLoad.value);
        percentage.value = 0;
      }

      intervalLoad.value = setInterval(async () => {
        percentage.value = percentage.value + 1;
        if (percentage.value >= 100) {
          clearInterval(intervalLoad.value);
          intervalLoad.value = null;
        }
      }, 600);
    };

    const createWatcher = () => {
      if (intervalStatus.value) {
        clearInterval(intervalStatus.value);
      }

      intervalStatus.value = setInterval(async () => {
        const response = await store.dispatch("checkStatusOnce");

        if (watcherTimer.value === 30000) {
          watcherTimer.value = 10000;
          clearInterval(intervalStatus.value);
          createWatcher();
        }

        if (response && response.image_url) {
          clearInterval(intervalStatus.value);
          intervalStatus.value = null;
          store.commit("clearOrderId");
          watcherTimer.value = 30000;
        }
      }, watcherTimer.value);
    };

    const downloadImage = async (event) => {
      try {
        const response = await fetch(generatedImage.value);
        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "downloaded_image.png";
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Ошибка при скачивании изображения:", error);
      }
    };

    onMounted(() => {
      const rulesCookie = getCookie('rules-accepted');

      if (!rulesCookie) {
        setTimeout(() => {
          store.commit('addModal', 'RulesModal')
        }, 1500)
      }
    })

    return {
      // refs
      step,
      currentImage,
      isGenerating,
      percentage,
      images,
      isOpenAgeVerificationModal,
      requestId,

      // computed
      generatedImage,
      isInOrder,

      // methods
      changeStepOne,
      changeStepTwo,
      handleDrop,
      handleGenerate,
      handleFile,
      handleFilter,
      redirectToSignUp,
      openPopupMore,
      openPopupOver,
      downloadImage,
      justUndressRequest,
      uploadNewPhoto,
      removeImage
    }
  }
}
</script>

<style lang="scss" scoped>
  .c-single-generation {
    // overflow: hidden;
    &_wrapper {
      display: flex;
      align-items: flex-start;
      padding-left: 20px;
      padding-right: 20px;
      gap: 3vw;
      justify-content: space-between;

      @media screen and (max-width: 1024px) {
        &:not(.wrapper-filters) {
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
        &.wrapper-filters {
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
      }

      &-info {
        width: 80%;
        max-width: 460px;
        padding-top: 40px;
        display: flex;
        flex-direction: column;
        flex-grow: 0;
        gap: 30px;

        @media screen and (max-width: 1100px) {
          justify-content: center;
          align-items: center;
          text-align: center;
          width: 100%;
        }

        &-headline {
          font-size: 48px;
          color: #FFF;
          font-style: normal;
          font-weight: 600;
          line-height: 110%;
          letter-spacing: -1.92px;
          text-align: center;
          text-transform: capitalize;
          span {
            color: #b4f12f;
          }
          @media screen and (max-width: 950px) {
            font-size: 36px;
          }
        }
        &_button {
          width: 100%;

          :deep(button) {
            width: 100%;
            height: 60px;
            border-radius: 20px;
          }
        }
      }

      &-image-holder {
        width: 80%;
        height: 100%;
        max-width: 500px;
        padding-top: 40px;
        display: flex;
        flex-direction: column;
        flex-grow: 0;
        gap: 30px;

        @media screen and (max-width: 1100px) {
          justify-content: center;
          align-items: center;
          text-align: center;
          width: 100%;
        }

        &-item {
          height: 820px;
          padding: 40px;
          border-radius: 30px;
          background: #3E3E3E;
          display: flex;
          align-items: center;
          justify-content: center;

          @media screen and (max-width: 768px) {
            padding: 20px;
          }

          img {
            width: 100%;
          }
        }
      }

      &-right {
        position: relative;
        width: 80%;
        display: flex;
        flex-wrap: wrap;
        padding-top: 40px;
        flex-grow: 1;
        @media screen and (max-width: 550px) {
          width: 100% !important;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &-filters {
        position: relative;
        width: 100%;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        @media screen and (max-width: 1020px) {
          width: 100% !important;
        }

        &--mobile {
          display: none;
          @media screen and (max-width: 1020px) {
            display: block;
          }
        }

        &-title {
          color: #FFF;
          text-align: center;
          font-size: 36px;
          font-style: normal;
          font-weight: 700;
          line-height: 100%;
          text-transform: capitalize;

          @media screen and (max-width: 768px) {
            font-size: 28px;
          }

          @media screen and (max-width: 550px) {
            font-size: 24px;
          }

          span {
            color: #b4f12f;
          }
        }

        &-list {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: center;
          @media screen and (max-width: 1100px) {
            max-width: 60%;
          }
          @media screen and (max-width: 768px) {
            max-width: 80%;
          }
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &-line {
          height: 100%;
          width: 1px;
          background: #ACF601;

          @media screen and (max-width: 1020px) {
            display: none;
          }
        }

        &-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: calc(50% - 10px);
          cursor: pointer;

          &.inactive {
            .image-holder {
              position: relative;

              &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-image: url("../assets/img/stripes.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center;
                z-index: 1;
              }
            }
          }

          &.selected {
            .image-holder {
              border: 3px solid #ACF601;
            }
          }

          .image-holder {
            overflow: hidden;
            border-radius: 20px;
            background: #FFF;
            width: 100%;
            height: 181px;
            margin-bottom: 6px;

            @media screen and (min-width: 1024px) {
              &:hover {
                border: 3px solid #ACF601;
              }
            }

            @media screen and (max-width: 768px) {
              height: 160px;
            }

            @media screen and (max-width: 550px) {
              height: 120px;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }

          p {
            color: #FFF;
            text-align: center;
            font-size: 32px;
            font-style: normal;
            font-weight: 700;
            line-height: 100%;
            text-transform: capitalize;

            @media screen and (max-width: 768px) {
              font-size: 28px;
            }

            @media screen and (max-width: 550px) {
              font-size: 24px;
            }
          }
        }
      }

      &.wrapper-filters {
        display: grid;
        grid-template-columns: 1fr 2px 1fr;
        padding-top: 40px;

        .c-single-generation_wrapper-image-holder {
          width: 100%;
          height: 100%;
          padding-top: 0;
        }

        @media screen and (max-width: 1100px) {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;

          .c-single-generation_wrapper-image-holder {
            display: block;
            width: 100%;
            height: 100%;
            padding-top: 0;

            &-item {
              height: 80vw;
              min-height: 400px;
            }
          }
        }
      }

      &-footer {
        &_desc {
          p {
            color: #FFF;
            text-align: center;
            font-size: 22px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%;
            text-transform: capitalize;
            span {
              color: #b4f12f;
            }
          }
        }
      }
    }
    &_card-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      @media screen and (max-width: 1100px) {
        gap: 20px;
        justify-content: center;
      }
      @media screen and (max-width: 825px) {
        display: flex;
        flex-direction: column;
        width: 100%;
      }
      &_item {
        backdrop-filter: blur(48px);
        &:nth-child(2) {
          margin: 0 20px;
        }
        @media screen and (max-width: 825px) {
          width: 90%;
        }
      }
    }
  }

  .generation {
    &-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      border: 2px solid #ACF601;
      background: #2C2B2B;
      border-radius: 30px;
      height: auto;
      width: 100%;
      max-width: 1043px;
      margin: 0 auto 30px auto;
      padding: 29px 85px 25px;

      @media screen and (max-width: 1024px) {
        padding: 15px;
        // min-height: 550px;
        // height: 150vw;
      }

      &-image {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 10px;
        &_title {
          max-width: 250px;
          margin-top: 5px;
          color: #FFF;
          text-align: center;
          font-size: 26px;
          font-style: normal;
          font-weight: 500;
          line-height: 100%;
          text-decoration-line: underline;
          text-decoration-style: solid;
          text-decoration-skip-ink: none;
          text-decoration-color: #ACF601;
          text-decoration-thickness: 10%;
          text-underline-offset: auto;
          text-underline-position: from-font;
          text-transform: capitalize;
          opacity: 0.85;
          @media screen and (max-width: 550px) {
            font-size: 14px;
          }
        }
        &_description {
          margin-top: 10px;
          color: rgba(255, 255, 255, 0.50);
          text-align: center;
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: 100%;
          text-transform: capitalize;

          @media screen and (max-width: 550px) {
            font-size: 12px;
            text-align: center;
          }
        }
      }
    }

    &-text {
      text-align: center;
      font-size: 24px;
      font-weight: 700;
      margin: 10px auto 20px auto;
    }

    &_upload {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-items: center;
      width: 100%;
      height: 300px;
      position: relative;
      border-radius: 30px;
      border: 2px solid #ACF601;
      background: #3E3E3E;
      max-height: calc(100% - 147px);
      margin-bottom: 22px;

      @media screen and (max-width: 550px) {
        width: 100%;
        max-width: 100%;
        padding: 10px;
        height: auto;
      }

      &--removed {
        cursor: progress;
        border: none;
        border-radius: 8px;
        overflow: hidden;
      }

      &-icon {
        margin: 0 auto;
        @media screen and (max-width: 550px) {
          width: 40%;
        }
        &-done {
          width: 75%;
          margin: 0 auto;
          cursor: zoom-in;
          z-index: 4;
          @media screen and (max-width: 550px) {
            width: 100%;
          }
        }
      }
      &-image {
        margin: 0 auto;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-uploading {
      position: relative;
      width: 100%;
      margin: 0 auto;
      word-spacing: 2px;
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 15px;
      justify-content: center;
      height: 100%;
      line-height: 1.8;
      overflow: hidden;
      border-radius: 8px;
      &-info {
        width: 588px;
        max-width: 100%;
        height: 31px;
        flex-shrink: 0;
        color: #ACF601;
        text-align: center;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        text-transform: capitalize;
        position: absolute;
        bottom: 63px;
        left: 50%;
        transform: translateX(-50%);

        @media screen and (max-width: 1024px) {
          font-size: 24px;
          bottom: 40px;
        }

        @media screen and (max-width: 768px) {
          font-size: 20px;
          bottom: 35px;
        }

        @media screen and (max-width: 480px) {
          font-size: 16px;
          bottom: 30px;
        }
      }
      &-percentage {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #FFF;
        text-align: center;
        font-size: 40px;
        font-style: normal;
        font-weight: 800;
        line-height: 100%;
        text-transform: capitalize;
        white-space: nowrap;

        @media screen and (max-width: 1024px) {
          font-size: 24px;
        }

        @media screen and (max-width: 768px) {
          font-size: 20px;
        }

        @media screen and (max-width: 480px) {
          font-size: 16px;
        }
      }
      &-text-almost-complete {
        width: 588px;
        height: 31px;
        flex-shrink: 0;
        color: #ACF601;
        text-align: center;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);

        @media screen and (max-width: 1500px) {
          max-width: 80%;
          font-size: 24px;
          line-height: 27px;
        }

        @media screen and (max-width: 1024px) {
          font-size: 24px;
          top: 10px;
        }

        @media screen and (max-width: 768px) {
          font-size: 20px;
          top: 8px;
        }

        @media screen and (max-width: 480px) {
          font-size: 16px;
          top: 4px;
        }
      }
      &-text-after {
        width: 588px;
        height: 31px;
        flex-shrink: 0;
        color: #ACF601;
        text-align: center;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        text-transform: capitalize;
        position: absolute;
        bottom: 25px;
        left: 50%;
        transform: translateX(-50%);

        @media screen and (max-width: 1024px) {
          font-size: 24px;
          bottom: 10px;
        }

        @media screen and (max-width: 768px) {
          font-size: 20px;
          bottom: 8px;
        }

        @media screen and (max-width: 480px) {
          font-size: 16px;
          bottom: 4px;
        }
      }
      &--loader {
        position: absolute !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @media screen and (max-width: 550px) {
          //transform: scale(0.7);
          //left: 43%;
        }
        @media screen and (max-width: 460px) {
          //left: 35%;
        }
      }
      &--background {
        background-color: rgba(0, 0, 0, 0.4);
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .generation_upload-image {
        filter: blur(3px);
      }
    }

    &-info {
      width: 668px;
      max-width: 100%;
      flex-shrink: 0;
      color: #FFF;
      text-align: center;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%;
      text-transform: capitalize;
      margin-bottom: 30px;

      @media screen and (max-width: 1024px) {
        font-size: 20px;
        margin-bottom: 20px;
      }

      @media screen and (max-width: 768px) {
        font-size: 16px;
        margin-bottom: 15px;
      }

      span {
        text-transform: uppercase;
      }
    }
    &-invoke-filters {
      gap: 45px;
      display: flex;
      justify-content: center;
      margin-bottom: 15px;
      width: 100%;

      @media screen and (max-width: 650px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 20px;
        max-width: 100%;
        width: 100%;
      }

      &_button {
        border: none;
        min-width: 258px;
        box-shadow: 1px 2px 10px #67eb00;
        outline: none;
        transition: all 0.3s;
        border-radius: 20px;
        background: #ACF601;
        height: 71px;
        color: #000;
        text-align: center;
        font-size: 26px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        text-transform: capitalize;
        &:hover {
          box-shadow: 1px 2px 25px #67eb00;
          color: rgba(0, 0, 0, 1);
        }
        &--disabled {
          opacity: 0.55;
          cursor: not-allowed;
        }

        @media screen and (max-width: 1024px) {
          font-size: 20px;
          height: 50px;
          border-radius: 10px;
        }

        @media screen and (max-width: 768px) {
          font-size: 16px;
          height: 40px;
          border-radius: 8px;
        }

        @media screen and (max-width: 650px) {
          width: 100%;
        }
      }
      &-cancel {
        border: none;
        min-width: 258px;
        border-radius: 20px;
        background: #963333;
        box-shadow: 1px 2px 10px rgb(222, 8, 47);
        cursor: pointer;
        outline: none;
        transition: all 0.3s;
        height: 71px;
        color: #fff;
        text-align: center;
        font-size: 26px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        text-transform: capitalize;
        white-space: pre-wrap;
        &--once {
          min-width: 258px;
        }
        &:hover {
          box-shadow: 1px 2px 25px rgb(222, 8, 47);
        }
        &--disabled {
          filter: grayscale(1);
          color: #f5f5f59e;
        }

        @media screen and (max-width: 1024px) {
          font-size: 20px;
          height: 50px;
          border-radius: 10px;
        }

        @media screen and (max-width: 768px) {
          font-size: 16px;
          height: 40px;
          border-radius: 8px;
        }

        @media screen and (max-width: 650px) {
          width: 100%;
        }
      }
    }
  }

  .zoom-image-buttons {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 15px;
    position: absolute;
    gap: 15px;
    top: 10px;
    left: 20px;

    button {
      width: 30px;
      height: 30px;
      padding: 3px;
      border: none;
      background-color: rgba(150, 150, 150, .5);
      border-radius: 5px;
      cursor: pointer;
    }

    img  {
      width: 100%;
      object-fit: cover;
      height: 100%;
      max-height: 700px;
    }
  }

  .wrapper-generation {
    padding-top: 40px;
    .generation_upload {
      height: 100%;
    }
  }
</style>
